
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <div className="flex items-center mb-12">
            <img 
              src="https://public.readdy.ai/ai/img_res/d4f551a0-0f82-4a97-9c1e-d5ecd7883897.png" 
              alt="DEN d.o.o. Logo" 
              className="h-12 w-auto mr-4"
            />
            <h2 className="text-6xl font-bold">DEN d.o.o.</h2>
          </div>
        </div>
        
        <div className="grid lg:grid-cols-3 gap-12 mb-12">
          <div className="space-y-8">
            <p className="text-white/70 leading-relaxed max-w-sm">
              Protecting your digital privacy with advanced VPN technology. 
              Fast, secure, and reliable connections to keep your online activities private and safe.
            </p>
            
            <div className="flex space-x-5">
              <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:border-white/60 transition-colors">
                <i className="ri-linkedin-line text-white text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:border-white/60 transition-colors">
                <i className="ri-twitter-line text-white text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:border-white/60 transition-colors">
                <i className="ri-facebook-line text-white text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:border-white/60 transition-colors">
                <i className="ri-instagram-line text-white text-lg"></i>
              </a>
            </div>
          </div>
          
          <div className="space-y-8">
            <div>
              <div className="text-xs uppercase text-white/50 font-medium tracking-wide mb-2">ADDRESS</div>
              <div className="text-white/80 space-y-1">
                <div>Savudrijska ulica - Via Salvore 1</div>
                <div>52100 Pula</div>
                <div>Croatia</div>
              </div>
            </div>
            
            <div>
              <div className="text-xs uppercase text-white/50 font-medium tracking-wide mb-2">PHONE</div>
              <a href="tel:+12316608214" className="text-white/80 hover:text-white transition-colors">
                +1 2316608214
              </a>
            </div>
            
            <div>
              <div className="text-xs uppercase text-white/50 font-medium tracking-wide mb-2">EMAIL</div>
              <a href="mailto:support@den-doo.com" className="text-white/80 hover:text-white transition-colors">
                support@den-doo.com
              </a>
            </div>
          </div>
          
          <div className="lg:flex lg:justify-end">
            <img 
              src="https://public.readdy.ai/ai/img_res/d3978ff08784f350ae41c0681da06b82.jpg"
              alt="DEN d.o.o. Team"
              className="w-full lg:w-70 h-90 object-cover rounded-xl border border-white/10"
            />
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-white/60 text-sm">
              © 2025 DEN d.o.o. All rights reserved.
            </div>
            
            <div className="flex space-x-8 text-sm">
              <a href="#" className="text-white/60 hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="text-white/60 hover:text-white transition-colors">Terms of Service</a>
              <a href="https://readdy.ai/?origin=logo" className="text-white/60 hover:text-white transition-colors">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
